import { useQuote } from "@/common/contexts/QuoteResults.context";
import { Checkbox } from "antd";

export default function PickQuoteLineElement({ data }: { data: any }) {
  const { pickedQuotes, setPickedQuote } = useQuote();
  const pickedQuoteLine = pickedQuotes.find(
    (el) => el.quoteReqId === data.quoteReqId
  );
  const isChecked = pickedQuoteLine
    ? pickedQuoteLine.quoteLines.some(
        (item: any) =>
          item.quoteLineId === data.id && item.vendorId === data.price.companyId
      )
    : false;

  const handleChange = () => {
    const pickedQuoteData = {
      pikedQuoteId: data.quoteReqId,
      pickedQuoteLineId: {
        quoteLineId: data.id,
        vendorId: data.price.companyId,
      },
    };
    setPickedQuote(pickedQuoteData);
  };
  return (
    <div>
      <Checkbox checked={isChecked} onChange={handleChange} />
    </div>
  );
}
